var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Nastavenie brokera")]), !_vm.loading ? _c('button', {
    staticClass: "w-button saveformBtn",
    on: {
      "click": _vm.saveStaffProfile
    }
  }, [_vm._v("Uložiť")]) : _c('v-progress-circular', {
    staticClass: "loading-spinner small transparent",
    attrs: {
      "indeterminate": ""
    }
  })], 1), _vm.staffProfile ? _c('div', {
    staticClass: "popup-block flex-column broker-profile-card"
  }, [_c('div', {
    staticClass: "broker-profile-card-header"
  }, [_c('span', {
    staticClass: "broker-profile-label"
  }, [_vm._v("Lokalita")]), _c('button', {
    staticClass: "broker-profile-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openBrokerLocalityServed
    }
  }, [_vm._v("Editovať")])]), _c('div', {
    staticClass: "broker-districts"
  }, [_vm._v(" " + _vm._s(_vm.districtNames || "Nie je nastavená žiadna lokalita") + " ")])]) : _vm._e(), _vm.staffProfile ? _c('button', {
    staticClass: "popup-block broker-pooling-toggle",
    "class": {
      active: _vm.staffProfile.is_pooled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.togglePooling
    }
  }, [_vm._m(0), _c('span', [_vm._v(" Prideľovanie aktívne "), _c('small', [_vm._v(_vm._s(_vm.staffProfile.is_pooled ? "Finančník prijíma automaticky prideľované leady." : "Finančník je mimo automatického prideľovania."))])])]) : _vm._e(), _vm.error ? _c('div', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "toggle-track"
  }, [_c('span', {
    staticClass: "toggle-thumb"
  })]);

}]

export { render, staticRenderFns }